<template>
  <table
    class="Table Table--Sticky Table--Stripped bg-white rounded-md shadow mb-8"
  >
    <slot name="header"></slot>
    <slot name="body"></slot>
  </table>
</template>

<script>
export default {
  props: {}
}
</script>

<style lang="scss" scoped>
@media (max-width: 600px) {
  .Table--Sticky {
    @apply static;
  }
  .Table {
    tr:first-child {
      @apply hidden;
    }
  }
}
</style>
